import React from 'react';
import { Button, Grid, IconButton } from '@mui/material';
import { handleImageInput } from 'src/utils/functions';
import { styled } from '@mui/material/styles';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

interface ImageInputProps {
  cta: string;
  images: string[];
  setImages: React.Dispatch<React.SetStateAction<string[]>>;
  maxImageCount?: number;
  maxSizeInMb?: number;
}

const ImageInput: React.FC<ImageInputProps> = ({
  cta,
  images,
  setImages,
  maxImageCount = 1,
  maxSizeInMb = 10,
}) => {
  const handleImageUpload = async values => {
    const remainingSlots = maxImageCount - images.length;

    if (remainingSlots <= 0) {
      alert(`Maximum number of images (${maxImageCount}) reached`);
      return;
    }

    try {
      const data = (await handleImageInput(values, maxSizeInMb)) as string;
      setImages(prev => [...prev, data]);
    } catch (error) {
      alert(error);
    }
  };

  return (
    <Grid
      item
      container
      sm={12}
      md={6}
      spacing={2}
      flexDirection={'column'}
      alignItems={'flex-start'}
      justifyContent={'flex-start'}
    >
      <Grid item>
        <Button
          fullWidth
          component="label"
          role={undefined}
          variant="outlined"
          tabIndex={-1}
          startIcon={<AddPhotoAlternateIcon />}
        >
          {cta}
          <VisuallyHiddenInput
            type="file"
            onChange={event => handleImageUpload(event.target.files)}
            multiple
          />
        </Button>
      </Grid>

      <Grid item container spacing={1} alignItems="center">
        {images && images.length > 0 && (
          <>
            <Grid item>
              <img
                src={images[0]}
                style={{ width: '80px', height: '40px', objectFit: 'contain' }}
              />
            </Grid>
            <Grid item>
              <IconButton size="small" onClick={() => setImages([])}>
                <CloseRoundedIcon />
              </IconButton>
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default ImageInput;
